import React from "react";
import { Alert, AlertTitle } from '@mui/material';

export enum EAlertSeverity {
    Success = "success",
    Error = "error",
    Warning = "warning",
}

export interface IStatusAlertProps {
    severity: EAlertSeverity;
    title: string;
    message: string;
    serverError?: string;
}

const StatusAlert = ({ severity, title, message, serverError }: IStatusAlertProps) => {
    console.log("StatusAlert Props:", { severity, title, message, serverError });

    return (
        <Alert severity={severity}>
            <AlertTitle>{title}</AlertTitle>
            {message}
            {serverError && (
                <p style={{ marginTop: 8, marginBottom: 0, opacity: 0.8, fontSize: "0.85em" }}>
                    Server details: {serverError}
                </p>
            )}
        </Alert>
    );
};

export default StatusAlert;
